module.exports = __webpack_public_path__ + "KY.png?ec197b2fdccdaea26202f329cf130abb";